import { FC } from 'react'

import TrainingGroupRequirementsFormFields from './training-group-requirements-form-fields'

import { ITrainingGroupRequirementsFormProps } from './training-group-requirements-form-types'

import s from '../../../../features/admin-training/admin-training.module.scss'

const TrainingGroupRequirementsForm: FC<ITrainingGroupRequirementsFormProps> = props => {
  const { handleSubmit, formName, submitting } = props

  return (
    <>
      <div className={`${s['container-gray']} border rounded p-4`}>
        Select the training types required for this group. These will be suggested in the "Personnel Requirements" tab when 
        assigning training to group members.
      </div>
      
      <form onSubmit={handleSubmit} id={formName}>
        <TrainingGroupRequirementsFormFields disabled={submitting} />
      </form>
    </>
  )
}

export default TrainingGroupRequirementsForm
